import styled from 'styled-components'
import Flex from 'components/priority/Flex/Flex'

export const Login = styled(Flex)``
